"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BbrBank = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BbrBank = function BbrBank(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.619 6.406a.065.065 0 00-.005-.09c-.08-.068-.157-.135-.239-.2A5.262 5.262 0 006.128 5a5.29 5.29 0 00-1.485.21 5.182 5.182 0 00-2.41 1.506c-.491.653-.694 1.189-.776 1.489a8.46 8.46 0 00-.2 1.5 8.608 8.608 0 002.602 6.5 8.943 8.943 0 006.088 2.543c.067.002.136.002.202.002 2.93 0 5.673-1.409 7.34-3.765a.063.063 0 00-.009-.083.07.07 0 00-.048-.02.11.11 0 00-.039.01 5.98 5.98 0 01-3.214.933 5.936 5.936 0 01-4.804-2.421 5.657 5.657 0 01-1.1-3.33A5.708 5.708 0 019.62 6.406z",
    fill: "#00447C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.766 13.28c.492-.653.695-1.189.777-1.489a8.69 8.69 0 00.2-1.503 8.589 8.589 0 00-2.602-6.495 8.97 8.97 0 00-6.088-2.54c-.067-.003-.136-.003-.202-.003-.262 0-.523.012-.782.035-2.633.225-5.042 1.583-6.557 3.729a.067.067 0 00.007.085.07.07 0 00.05.02.085.085 0 00.035-.01 5.943 5.943 0 013.214-.933c1.198 0 2.315.353 3.248.955 1.39.898 2.369 2.351 2.6 4.032a5.69 5.69 0 01-1.292 4.432.063.063 0 00.007.09A5.247 5.247 0 0013.867 15a5.29 5.29 0 001.484-.21 5.202 5.202 0 002.415-1.51z",
    fill: "#00447C"
  }));
};

exports.BbrBank = BbrBank;
var _default = BbrBank;
exports.default = _default;